import { exports as s, __module as d } from "../../../_virtual/FunctionStateMap.mjs";
import "./constants/PlayerStates.mjs";
import { exports as f } from "../../../_virtual/PlayerStates.mjs";
(function(u, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  });
  var l = f, e = r(l);
  function r(t) {
    return t && t.__esModule ? t : { default: t };
  }
  a.default = {
    pauseVideo: {
      acceptableStates: [e.default.ENDED, e.default.PAUSED],
      stateChangeRequired: !1
    },
    playVideo: {
      acceptableStates: [e.default.ENDED, e.default.PLAYING],
      stateChangeRequired: !1
    },
    seekTo: {
      acceptableStates: [e.default.ENDED, e.default.PLAYING, e.default.PAUSED],
      stateChangeRequired: !0,
      // TRICKY: `seekTo` may not cause a state change if no buffering is
      // required.
      // eslint-disable-next-line unicorn/numeric-separators-style
      timeout: 3e3
    }
  }, u.exports = a.default;
})(d, s);
//# sourceMappingURL=FunctionStateMap.mjs.map
